<template>
  <div>
    <video
      width="100%"
      height="100%"
      class="home-vdo"
      ref="videoElement"
      autoplay
      muted
      playsinline
      preload="auto"
      @ended="handleVideoEnd"
    >
      <source src="https://21impact.blob.core.windows.net/shareinvestorthailand/overview-video.mp4" type="video/mp4" />
    </video>
  </div>
</template>

<script setup>
import { ref, onMounted, defineEmits } from 'vue';
const videoElement = ref(null);
const emit = defineEmits(['videoEnded']);
const handleVideoEnd = () => {
 
  emit('videoEnded');
  
  if (videoElement.value) {
    videoElement.value.style.display = 'none'; 
  }
};
onMounted(() => {
  if (videoElement.value) {
    videoElement.value.play(); 
  }
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";
.home-vdo {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
  display: block;
  opacity: 1; 
  transition: opacity 0.3s ease;
  z-index: 110000;
  @include media-breakpoint-down(md) {
    display: none;
  }
}
</style>